export default __webpack_public_path__ + "static/media/img-o-n-memberships-and-wallets.1381c64f.png";